import DetailColumns from "./DetailColumns";
import {html} from "@isceco/widget-library2/external/lit";
import {StaticList} from '@isceco/widget-library2/basic-elements/List/StaticList.js'

export default class StaticDetailList extends StaticList {
  constructor() {
    super()
    this.columns = DetailColumns.getColumns()
  }

  // Override StaticList._renderHeader
  _renderHeader = () => html``

}
customElements.define('eko-static-detail-list', StaticDetailList)
